/* Armodilo worship landing page. Minified — readable source in worship.js.txt. */
(function () {
'use strict';
var MAP = window.WORSHIP_ASSETS || {};
function A(f) { return MAP[f] || f; }
function setOf(src) {
var base = src, m = /([^/]+)\.webp(\?.*)?$/.exec(src);
if (!m) return '';
var out = [];
[440, 640].forEach(function (w) {
var name = m[1] + '-' + w + 'w.webp';
if (MAP[name]) out.push(MAP[name] + ' ' + w + 'w');
});
out.push(base + ' 1000w');
return out.join(', ');
}
const COLLECTION = { s1: 'freestanding', s2: 'desktop', s3: 'wall', s4: 'branding' };
const DATA = {
s1: {
label: "Welcome & check-in",
models: [
{
url: "https://armodilo.com/products/alur",
name: "Alur", kicker: "The welcome center",
title: "Your welcome center's first impression.",
price: "$959", priceNote: "excl. tax · 14″ or 16″",
body: "A slim floor-standing kiosk in steel and aluminium with high-gloss painted front and back panels, and quick-change magnetic graphic panels that swap sermon-series art or campus branding in seconds — no tools, no reprinting the kiosk. ArmoLock™ security screws, a swappable tablet carrier, and cabling routed inside the column and out the back near the base so the tablet never loses power.",
ideal: "The first kiosk a guest meets — lobby greeting, service times, event sign-up and giving, in a foyer where the kiosk is seen from every angle and has to look intentional. ADA compliant, landscape orientation.",
specs: [
{ k: "Price", v: "$959 excl. tax" },
{ k: "Sizes", v: "14″ for 9–10″ tablets · 16″ for 11–12″" },
{ k: "Tablet brands", v: "Acer, Amazon, Apple, Chuwi, Lenovo, Microsoft, Samsung" },
{ k: "Body", v: "Steel and aluminium, high-gloss painted panels" },
{ k: "Orientation", v: "Landscape only" },
{ k: "Security", v: "ArmoLock™ screws, fully enclosed carrier" },
{ k: "Venting", v: "Passive thermal — vents top and bottom" },
{ k: "Lead time", v: "4–6 weeks if not in stock" },
{ k: "Add-ons", v: "Magnetic panel $90 · Power cover $48 · Data cables $16" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('alur-white.webp'), alt: "Alur freestanding tablet kiosk in white gloss, front and rear panels shown" },
{ src: A('alur-three.webp'), alt: "Three Alur iPad kiosks side by side showing the magnetic graphic panel options" },
{ src: A('alur-office.webp'), alt: "Alur tablet kiosk greeting visitors in a reception area" },
{ src: A('alur-office2.webp'), alt: "Three Alur freestanding kiosks arranged as a welcome and check-in line" }
]
},
{
url: "https://armodilo.com/products/floor",
name: "Floor", kicker: "Children's ministry",
title: "Children's check-in, made safe & simple.",
price: "$479", priceNote: "excl. tax · black or white",
body: "The award-winning workhorse of children’s ministry: ABS and aluminium, only 12 lbs, so a volunteer can carry it between rooms. Portrait or landscape, fully integrated cable routing, a Quick Connect port, and a shelf add-on that carries a label printer for matching parent and child ID tags.",
ideal: "Secure sign-in and sign-out for kids’ ministry, and any room that needs ID tags printed at the point of check-in. Light enough to move between a permanent campus and a rented venue. ADA compliant.",
specs: [
{ k: "Price", v: "$479 excl. tax" },
{ k: "Colours", v: "Black, White" },
{ k: "Weight", v: "12 lbs — aluminium, easy to move" },
{ k: "Orientation", v: "Portrait or landscape" },
{ k: "Tablet brands", v: "Apple, Samsung, Microsoft, Lenovo, Acer, Google, HP, Dell + more" },
{ k: "Security", v: "ArmoLock™ screws, Quick Connect port" },
{ k: "Lead time", v: "Up to 2 weeks (made to order)" },
{ k: "Add-ons", v: "Shelf $49 · ArmoTwist $99 · Keyboard tray $49" },
{ k: "Also fits", v: "Monitors via the VESA adaptor $69" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('floor-white.webp'), alt: "Floor freestanding tablet kiosk in white, front view for church check-in" },
{ src: A('floor-black.webp'), alt: "Floor freestanding tablet kiosk in black, front view for church check-in" },
{ src: A('floor-white-rear.webp'), alt: "Rear of the Floor tablet kiosk showing fully internal cable routing" },
{ src: A('floor-black2.webp'), alt: "Floor tablet kiosk in black, three-quarter view on its aluminium stand" }
]
}
]
},
s2: {
label: "Giving & welcome desk",
models: [
{
url: "https://armodilo.com/products/sphere",
name: "Sphere", kicker: "Giving",
title: "Giving made effortless.",
price: "$279", priceNote: "excl. tax · black or white",
body: "An award-winning countertop enclosure in steel and ABS that flips a full 90° so the same screen serves both sides of a desk — the giver taps, the volunteer confirms. Heavy enough to stay put, with hardware included to fix it to any counter up to 2″ thick.",
ideal: "One-time and recurring giving at the welcome desk, plus card-present payments at a bookstore or café counter. The tilt is what makes it work for PIN entry and signatures without anyone walking around the desk.",
specs: [
{ k: "Price", v: "$279 excl. tax" },
{ k: "Colours", v: "White, Black" },
{ k: "Tilt", v: "90° range, cycle-tested past 20,000 movements" },
{ k: "Mounting", v: "Free-sitting or fixed to counters up to 2″" },
{ k: "Orientation", v: "Landscape or portrait" },
{ k: "Signal", v: "Wi-Fi and Bluetooth transparent" },
{ k: "Security", v: "ArmoLock™ screws, Quick Connect port" },
{ k: "Lead time", v: "Up to 2 weeks (made to order)" },
{ k: "Add-ons", v: "Optional rotational base" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('sphere-pair.webp'), alt: "Sphere countertop tablet kiosks in black and white for church giving stations" },
{ src: A('sphere-black-rear.webp'), alt: "Rear of the Sphere countertop kiosk in black, showing the tilting head mount" },
{ src: A('sphere-white-rear.webp'), alt: "Rear of the Sphere countertop kiosk in white, showing the cable exit" },
{ src: A('sphere-retail.webp'), alt: "Sphere tablet kiosk in use at a welcome counter for card payments" }
]
},
{
url: "https://armodilo.com/products/curve",
name: "Curve", kicker: "Reception & info point",
title: "A browsing station for the welcome desk.",
price: "$279", priceNote: "excl. tax · black or white",
body: "A single-piece aluminium base holding the tablet at a low-glare angle — only 6.5 lbs, with mounting holes in the base for the day it becomes permanent. Armodilo’s own pick for shareable screens and catalogue browsing.",
ideal: "Browsing rather than transacting: bulletins, programs, ministry directories, sermon archives — a screen two people can read together without anyone reaching for it.",
specs: [
{ k: "Price", v: "$279 excl. tax" },
{ k: "Colours", v: "Black, White" },
{ k: "Weight", v: "6.5 lbs — ABS and aluminium" },
{ k: "Orientation", v: "Landscape or portrait" },
{ k: "Mounting", v: "Base holes for permanent install" },
{ k: "Tablet width", v: "Up to 12.5″ via Tablet Fit Kit™" },
{ k: "Security", v: "ArmoLock™ screws, Quick Connect port" },
{ k: "Lead time", v: "Up to 2 weeks (made to order)" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('curve-white.webp'), alt: "Curve countertop tablet stand in white, front view for lobby browsing" },
{ src: A('curve-black.webp'), alt: "Curve countertop tablet stand in Black Edition, front view" },
{ src: A('curve-white-rear.webp'), alt: "Rear of the Curve tablet stand in white, showing the single-piece aluminium base" },
{ src: A('curve-black-rear.webp'), alt: "Rear of the Curve tablet stand in Black Edition, showing the cable channel" }
]
},
{
url: "https://armodilo.com/products/spot",
name: "Spot", kicker: "Volunteer-roaming check-in",
title: "Three pounds, picked up and carried.",
price: "$191", priceNote: "excl. tax · black or white",
body: "The lightest enclosure in the line — 3 lbs of rugged ABS on a four-way standing peg, designed to be moved rather than bolted down. Set it on any surface in any orientation, with a Quick Connect port that takes a Kensington-style cable when it does stay put.",
ideal: "Overflow Sundays, special events, and a volunteer walking the lobby taking sign-ups. Also right for a second check-in point you only set up once a month, or a reading station in a library corner.",
specs: [
{ k: "Price", v: "$191 excl. tax" },
{ k: "Colours", v: "Black, White" },
{ k: "Weight", v: "3 lbs — the lightest in the line" },
{ k: "Base", v: "Four-way standing peg, any orientation" },
{ k: "Security", v: "ArmoLock™ screws, Kensington-compatible port" },
{ k: "Cabling", v: "Fully internal routing" },
{ k: "Tablet brands", v: "Apple, Samsung, Microsoft, Lenovo, Acer + more" },
{ k: "Lead time", v: "Up to 2 weeks (made to order)" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('spot-white-side.webp'), alt: "Spot portable tablet kiosk in white, side profile showing the ball-joint mount" },
{ src: A('spot-black-rear.webp'), alt: "Rear of the Spot portable tablet kiosk in black" },
{ src: A('spot-base.webp'), alt: "Base of the Spot tablet kiosk with the cable pass-through, viewed from above" },
{ src: A('spot-pivot.webp'), alt: "Pivot socket on the Spot tablet kiosk base, allowing any screen orientation" }
]
},
{
url: "https://armodilo.com/products/surface",
name: "Surface", kicker: "Shared desk screen",
title: "One screen, two people, no reaching over.",
price: "$279", priceNote: "excl. tax · black or white",
body: "The desktop configuration of Armodilo’s award-winning Surface — an aluminium armature on a desk mount, 5 lbs, fully enclosed, with every cable hidden inside. Add the swivel base and the same screen serves the volunteer on one side and the visitor on the other.",
ideal: "Welcome desks and reception counters where staff and guest both need the screen — registration, giving, lookup. The swivel base is what removes the awkward turning of a whole stand.",
specs: [
{ k: "Price", v: "$279 excl. tax" },
{ k: "Colours", v: "White, Black" },
{ k: "Weight", v: "5 lbs — aluminium and ABS" },
{ k: "Mounting", v: "Table or desktop" },
{ k: "Movement", v: "Optional swivel base for multi-user desks" },
{ k: "Orientation", v: "Landscape or portrait" },
{ k: "Cabling", v: "Fully internal, tamper-resistant" },
{ k: "Security", v: "ArmoLock™ screws, Quick Connect port" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('surface-desk-white.webp'), alt: "Surface tablet mount in white on its desk base for a shared welcome desk" },
{ src: A('surface-desk-black.webp'), alt: "Surface tablet mount in black on its desk base" },
{ src: A('surface-swivel.webp'), alt: "Surface tablet mounts on swivel bases in white and black, for multi-user desks" }
]
},
{
url: "https://armodilo.com/products/keyo",
name: "Keyo", kicker: "Counter enclosure",
title: "Room inside for the card reader.",
price: "$255", priceNote: "excl. tax · three sizes",
body: "The surface-mount configuration of Keyo: formed aluminium with rivets for strength, a deep cavity behind the tablet for cables and peripherals, and easy front access on a secure key lock. Sits at a 20° angle, so a standing visitor reads it without stooping.",
ideal: "Giving stations and welcome counters where a card reader, PoE board or scanner lives inside the enclosure rather than hanging off it — and where a volunteer must not be able to open it.",
specs: [
{ k: "Price", v: "$255 excl. tax" },
{ k: "Colours", v: "Sky White, Black" },
{ k: "Sizes", v: "Small, Regular, Large — tablets to 12.5″ wide" },
{ k: "Access", v: "Front opening on a secure key lock" },
{ k: "Angle", v: "20° viewing angle" },
{ k: "Peripherals", v: "Interchangeable side panels — card readers, scanners" },
{ k: "Orientation", v: "Landscape (ask about portrait)" },
{ k: "Lead time", v: "Up to 2 weeks (made to order)" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('keyo-desk-white.webp'), alt: "Keyo secure tablet enclosure in Sky White on a surface mount" },
{ src: A('keyo-desk-black.webp'), alt: "Keyo secure tablet enclosure in black on a surface mount" }
]
}
]
},
s3: {
label: "Directories & multi-campus",
models: [
{
url: "https://armodilo.com/products/surface",
name: "Surface", kicker: "Shared directory",
title: "A directory that turns to face the visitor.",
price: "$278", priceNote: "excl. tax · black or white",
body: "An award-winning aluminium armature for wall, table or desktop — 5 lbs, fully enclosed, with every cable hidden inside. Add ArmoTwist for 360° rotation and 50° pivot, or a swivel base for a desk two people share.",
ideal: "A lobby directory or welcome-desk screen that has to face a different visitor every few minutes, and shared reception desks where staff and guest both need the screen.",
specs: [
{ k: "Price", v: "$278 excl. tax" },
{ k: "Colours", v: "Black, White" },
{ k: "Weight", v: "5 lbs — aluminium and ABS" },
{ k: "Tablet brands", v: "Acer, Amazon, Apple, Asus, Chuwi, Dell, ELO, Google, HP, Lenovo, Microsoft, Samsung, Sony" },
{ k: "Mounting", v: "Wall, table or desktop" },
{ k: "Movement", v: "Optional ArmoTwist — 360° rotation, 50° pivot" },
{ k: "Orientation", v: "Landscape or portrait" },
{ k: "Cabling", v: "Fully internal, tamper-resistant" },
{ k: "Security", v: "ArmoLock™ screws, Quick Connect port" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('surface-wall-white.webp'), alt: "Surface tablet mount in white, wall mounted as a lobby directory" },
{ src: A('surface-wall-black.webp'), alt: "Surface tablet mount in black, wall mounted as a lobby directory" },
{ src: A('surface-wall-black2.webp'), alt: "Surface wall-mounted tablet enclosure in black, side profile" },
{ src: A('surface-wall-black3.webp'), alt: "Surface wall-mounted tablet enclosure in black, angled to face a visitor" }
]
},
{
url: "https://armodilo.com/products/tilt",
name: "Tilt", kicker: "Low-footprint touchpoint",
title: "For the pillar and the narrow hallway.",
price: "$239", priceNote: "excl. tax · black or white",
body: "Wall or surface mounted with a built-in 90° tilt — 45° each side, the same mechanism as Sphere, cycle-tested past 20,000 movements. Four pounds of ABS and aluminium with a steel faceplate, and no floor space given up.",
ideal: "Foyer pillars, narrow corridors and classroom doorways. Also the cheapest way to add a second check-in point to a room that already has one, since it needs a wall rather than a footprint.",
specs: [
{ k: "Price", v: "$239 excl. tax" },
{ k: "Colours", v: "Black, White" },
{ k: "Movement", v: "90° range — 45° each side" },
{ k: "Durability", v: "Tested past 20,000 movements" },
{ k: "Weight", v: "4 lbs — aluminium and ABS" },
{ k: "Mounting", v: "Wall or surface" },
{ k: "Orientation", v: "Landscape or portrait" },
{ k: "Security", v: "ArmoLock™ screws, Quick Connect port" },
{ k: "Lead time", v: "Up to 2 weeks (made to order)" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('tilt-white.webp'), alt: "Tilt adjustable wall mount in white holding a tablet at eye level" },
{ src: A('tilt-black.webp'), alt: "Tilt adjustable wall mount in black, angled to show its 90 degree tilt range" }
]
},
{
url: "https://armodilo.com/products/keyo",
name: "Keyo", kicker: "Counter & POS-adjacent",
title: "Room inside for the peripherals.",
price: "$223", priceNote: "excl. tax · three sizes",
body: "Formed aluminium with rivets for strength, and a deep cavity behind the tablet for cables, PoE boards, USB hubs or biometric scanners. Opens from the front on a secure key lock, sits at a 20° viewing angle, and can mount straight over an electrical wall plate.",
ideal: "Counters where hardware lives inside the enclosure rather than hanging off it: giving stations with a card reader, security desks with a scanner, and any install a volunteer must not be able to open.",
specs: [
{ k: "Price", v: "$223 excl. tax" },
{ k: "Colours", v: "Sky White, Black" },
{ k: "Sizes", v: "Small, Regular, Large — tablets to 12.5″ wide" },
{ k: "Access", v: "Front opening on a secure key lock" },
{ k: "Angle", v: "20° viewing angle" },
{ k: "Power", v: "Mounts over an electrical wall plate" },
{ k: "Peripherals", v: "Interchangeable side panels — card readers, scanners" },
{ k: "Orientation", v: "Landscape (ask about portrait)" },
{ k: "Lead time", v: "Up to 2 weeks (made to order)" },
{ k: "Warranty", v: "Limited lifetime" }
],
shots: [
{ src: A('keyo-wall-white.webp'), alt: "Keyo secure tablet enclosure in Sky White, wall mounted beside a doorway" },
{ src: A('keyo-wall-black.webp'), alt: "Keyo secure tablet enclosure in black, wall mounted beside a doorway" }
]
},
{
url: "https://armodilo.com/products/outdoor-wall-mount-tablet-enclosure-bundle-without-tablet",
name: "Outdoor bundle", kicker: "Portable & outdoor campus",
title: "A virtual front desk, outside the doors.",
price: "$360", priceNote: "excl. tax · complete bundle",
body: "A complete bundle rather than a bare enclosure: camera-aligned faceplate for video reception, all-weather coating, sealed rear access, concealed cable routing, a 90° USB-C cable, mounting hardware, security screws and an install guide. Preconfigured for the Samsung Galaxy Tab Active5 (8″).",
ideal: "Entrances, gates, portables and tents — anywhere a live person greets a visitor by video, or a campus needs check-in before the doors open. Covered outdoor and semi-exposed locations.",
specs: [
{ k: "Price", v: "$360 excl. tax" },
{ k: "Colours", v: "Black, White" },
{ k: "Faceplate", v: "Camera-aligned for video reception" },
{ k: "Coating", v: "All-weather protective finish" },
{ k: "Included", v: "USB-C cable + 90° connector, screws, guide" },
{ k: "Cable length", v: "3 ft or 10 ft" },
{ k: "Tablet", v: "Samsung Galaxy Tab Active5 (8″) — ask for others" },
{ k: "Access", v: "Sealed rear panel, concealed routing" },
{ k: "Lead time", v: "Up to 2 weeks (coating application)" }
],
shots: [
{ src: A('outdoor.webp'), alt: "Outdoor wall-mount tablet enclosure used as a video front desk at an entrance" }
]
}
]
},
s4: {
label: "Make it your own",
models: [
{
url: "https://armodilo.com/products/printed-alur-graphic-panel",
name: "Magnetic panels", kicker: "Alur",
title: "New sermon art across every campus, in seconds.",
price: "$90", priceNote: "excl. tax · per printed panel",
body: "Alur’s magnetic graphic panels swap campaign messaging, sermon-series art or seasonal branding with no tools and no reprinting the kiosk. Full-colour printing through Armodilo’s in-house shop, with 14″ and 16″ artwork templates supplied.",
ideal: "Churches that change visual campaigns often, and multi-campus teams who need the same art up everywhere on the same Sunday.",
specs: [
{ k: "Price", v: "$90 excl. tax" },
{ k: "Model", v: "Alur only" },
{ k: "Templates", v: "14″ and 16″ artwork templates" },
{ k: "Artwork to", v: "sales@armodilo.com — proof sent for approval" },
{ k: "Change time", v: "Seconds, no tools" },
{ k: "Printing", v: "Full colour, in-house print shop" },
{ k: "Lead time", v: "Up to 2 weeks after proof approval" }
],
shots: [
{ src: A('mag-change.webp'), alt: "Alur tablet kiosks carrying printed magnetic wayfinding panels in a lobby" },
{ src: A('mag-custom.webp'), alt: "Printed magnetic graphic panel fitted to the column of an Alur tablet kiosk" },
{ src: A('alur-multi.webp'), alt: "Full-colour printed magnetic panel on an Alur kiosk column" },
{ src: A('mag-sportchek.webp'), alt: "Alur kiosk with a printed campaign panel, front and rear views" }
]
},
{
url: "https://armodilo.com/products/uv-printing",
name: "UV-printed faceplate", kicker: "Permanent branding",
title: "Full colour, printed into the faceplate.",
price: "$20", priceNote: "excl. tax · per faceplate",
body: "Vibrant UV-resistant graphics printed directly onto the faceplate — no vinyl edges to lift or peel. Standard printing places a 3×1″ logo anywhere on the plate; full-faceplate printing covers it edge to edge.",
ideal: "Permanent installs where the kiosk carries the church logo or campus name and will not be rebranded mid-life.",
specs: [
{ k: "Price", v: "$20 excl. tax" },
{ k: "Sizes", v: "Standard (3×1″ logo) or full faceplate" },
{ k: "Not available on", v: "Alur" },
{ k: "Templates", v: "Original: Large / Regular · Keyo: L / M / S" },
{ k: "Artwork to", v: "sales@armodilo.com — proof sent for approval" },
{ k: "Durability", v: "UV-printed, no peeling vinyl edges" },
{ k: "Lead time", v: "Up to 2 weeks after proof approval" }
],
shots: [
{ src: A('uv-1.webp'), alt: "UV-printed logo on the steel faceplate of an Armodilo tablet enclosure" },
{ src: A('uv-3.webp'), alt: "UV-printed tablet kiosk faceplates in several full-colour designs" }
]
},
{
url: "https://armodilo.com/products/laser-etching",
name: "Laser etching", kicker: "Understated mark",
title: "A quieter, monochrome signature.",
price: "$10", priceNote: "excl. tax · per faceplate",
body: "The laser removes paint to expose the steel base layer, leaving a clean monochrome logo, wordmark or icon. The understated option where a full-colour print would be too loud — and the least expensive branding Armodilo offers.",
ideal: "Sanctuary-facing kiosks and heritage buildings, where branding should be legible up close and invisible from the back row.",
specs: [
{ k: "Price", v: "$10 excl. tax" },
{ k: "Finish", v: "Monochrome — exposed steel base layer" },
{ k: "Not available on", v: "Alur, Gunmetal Grey paint" },
{ k: "Templates", v: "Original: Large / Regular · Keyo: L / M / S" },
{ k: "Artwork to", v: "sales@armodilo.com — proof sent for approval" },
{ k: "Volume", v: "Suits low and high volume alike" },
{ k: "Lead time", v: "Up to 2 weeks after proof approval" }
],
shots: [
{ src: A('etch.webp'), alt: "Laser-etched wordmark on the faceplate of an Armodilo tablet enclosure" }
]
},
{
url: "https://armodilo.com/products/healthcare-grade-protective-coating",
name: "Healthcare coating", kicker: "Wiped between services",
title: "Tested against the wipes you actually use.",
price: "$80", priceNote: "excl. tax · white gloss",
body: "A white gloss protective coating proven against 70% isopropyl alcohol wipes, CaviWipes™ and Oxivir® Tb — the underused answer for a check-in station cleaned between every service. Custom colours available on request.",
ideal: "Children’s check-in and nursery kiosks, and any station volunteers wipe down three times a Sunday.",
specs: [
{ k: "Price", v: "$80 excl. tax" },
{ k: "Finish", v: "White gloss (custom colours on request)" },
{ k: "Tested against", v: "70% isopropyl alcohol wipes" },
{ k: "Also tested", v: "CaviWipes™, Oxivir® Tb" },
{ k: "Sizes", v: "Regular stand or freestanding kiosk" },
{ k: "Lead time", v: "One additional week for application" },
{ k: "Note", v: "Highly resistant, but not corrosion-proof" }
],
shots: [
{ src: A('coating.webp'), alt: "Tablet enclosure with the healthcare-grade protective coating for wipe-down cleaning" }
]
},
{
url: "https://armodilo.com/collections/tablet-kiosk-customizations-and-branding",
name: "Graphic banners", kicker: "Floor",
title: "Signage that travels with the stand.",
price: "$40–$65", priceNote: "excl. tax · front or rear",
body: "Large-format printed panels sized for the Floor kiosk. The rear banner is heavyweight vinyl at 54.5×14″; the front panel is a standard 12×24″, customisable up to 24″ wide. Corner grommets make setup quick, and both pack down with the stand.",
ideal: "Conferences, outreach events, second campuses and pop-up venues where the kiosk doubles as the signage.",
specs: [
{ k: "Front panel", v: "$40 excl. tax — 12×24″, to 24″ wide" },
{ k: "Rear banner", v: "$65 excl. tax — 54.5×14″ heavyweight vinyl" },
{ k: "Model", v: "Floor" },
{ k: "Hardware", v: "Front $99 · rear assembly $128 (separate)" },
{ k: "Install", v: "Corner grommets" },
{ k: "Artwork to", v: "sales@armodilo.com — proof sent for approval" },
{ k: "Lead time", v: "Up to 2 weeks after proof approval" }
],
shots: [
{ src: A('banner-front.webp'), alt: "Floor tablet kiosk fitted with a printed front graphic panel for event signage" },
{ src: A('banner-rear.webp'), alt: "Floor tablet kiosk fitted with a large-format printed rear graphic banner" }
]
}
]
}
};
var st = { light: false, sent: false, s1: 0, s2: 0, s3: 0, s4: 0, i1: 0, i2: 0, i3: 0, i4: 0 };
var navRaf = 0, V = {};
function section(key) {
var idxKey = 'i' + key.slice(1);
var models = DATA[key].models;
var mi = Math.min(st[key], models.length - 1);
var m = models[mi], shots = m.shots;
var si = Math.min(st[idxKey], shots.length - 1), shot = shots[si];
var ref = m.name.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-' + COLLECTION[key];
return {
name: m.name, title: m.title, body: m.body, ideal: m.ideal,
price: m.price, priceNote: m.priceNote, url: m.url,
caption: m.name + ' \u00b7 ' + m.kicker,
photo: shot.src, photoSet: setOf(shot.src), alt: shot.alt,
specs: m.specs,
models: models.map(function (x) { return { name: x.name }; }),
dots: shots.map(function () { return {}; }),
mail: 'mailto:sales@armodilo.com'
+ '?subject=' + encodeURIComponent('Worship kiosks \u2014 ' + m.name + ' (' + COLLECTION[key] + ') enquiry [ref: worship-' + ref + ']')
+ '&body=' + encodeURIComponent(
'Model of interest: ' + m.name + ' (' + m.price + ')\n'
+ 'Collection: ' + DATA[key].label + '\n'
+ 'Source: Armodilo worship landing page\n\n'
+ 'Ministry / room:\n' + 'Tablet model:\n'
+ 'Number of stations:\n' + 'Timeline:\n\n' + 'Notes:\n'),
_mi: mi, _si: si, _len: shots.length, _idxKey: idxKey
};
}
function vals() {
return {
s1: section('s1'), s2: section('s2'), s3: section('s3'), s4: section('s4'),
themeLabel: st.light ? 'Dark' : 'Light',
quoteNote: st.sent ? 'Thanks \u2014 a specialist will reply today.' : ''
};
}
function get(o, path) {
var p = path.split('.'), v = o;
for (var i = 0; i < p.length; i++) { if (v == null) return undefined; v = v[p[i]]; }
return v;
}
function each(sel, fn) {
var l = document.querySelectorAll(sel);
for (var i = 0; i < l.length; i++) fn(l[i], i);
}
function fillOne(el, row) {
var k = el.getAttribute('data-fill');
if (row && row[k] !== undefined) el.textContent = row[k];
}
function render() {
V = vals();
each('[data-rep]', function (tpl) {
var list = get(V, tpl.getAttribute('data-rep')) || [];
var host = tpl.parentNode;
var made = host.querySelectorAll('[data-made]');
for (var d = made.length - 1; d >= 0; d--) made[d].parentNode.removeChild(made[d]);
for (var i = 0; i < list.length; i++) {
if (!tpl.content) continue;
var frag = tpl.content.cloneNode(true), el = frag.firstElementChild;
while (el) {
el.setAttribute('data-made', '');
el.setAttribute('data-idx', String(i));
if (el.hasAttribute('data-fill')) fillOne(el, list[i]);
var f = el.querySelectorAll('[data-fill]');
for (var k = 0; k < f.length; k++) fillOne(f[k], list[i]);
el = el.nextElementSibling;
}
host.appendChild(frag);
}
});
each('[data-fill]', function (el) {
if (el.closest('[data-made]') || el.closest('template')) return;
var t = get(V, el.getAttribute('data-fill'));
if (t !== undefined) el.textContent = t;
});
each('[data-src-fill]', function (el) {
var v = get(V, el.getAttribute('data-src-fill'));
if (v && el.getAttribute('src') !== v) el.setAttribute('src', v);
});
each('[data-srcset-fill]', function (el) {
var v = get(V, el.getAttribute('data-srcset-fill'));
if (v) el.setAttribute('srcset', v);
});
each('[data-alt-fill]', function (el) {
var v = get(V, el.getAttribute('data-alt-fill'));
if (v != null) el.setAttribute('alt', v);
});
each('[data-href-fill]', function (el) {
var v = get(V, el.getAttribute('data-href-fill'));
if (v) el.setAttribute('href', v);
});
['s1', 's2', 's3', 's4'].forEach(function (key) {
var v = V[key];
var row = document.querySelector('[data-sec="' + key + '"]');
if (row) each2(row, function (b, i) { b.setAttribute('data-on', i === v._mi ? '1' : '0'); });
var dots = document.querySelector('[data-dots="' + key + '"]');
if (dots) each2(dots, function (b, i) { b.setAttribute('data-on', i === v._si ? '1' : '0'); });
});
}
function each2(host, fn) {
var l = host.querySelectorAll('[data-idx]');
for (var i = 0; i < l.length; i++) fn(l[i], i);
}
document.addEventListener('click', function (e) {
var hit = e.target.closest('[data-act]');
if (!hit) return;
var act = hit.getAttribute('data-act');
var m = /^s([1-4])\.(pick|goto|prev|next)$/.exec(act);
if (m) {
var key = 's' + m[1], idxKey = 'i' + m[1];
if (m[2] === 'pick' || m[2] === 'goto') {
var btn = e.target.closest('[data-idx]');
if (!btn) return;
var i = Number(btn.getAttribute('data-idx'));
if (m[2] === 'pick') { st[key] = i; st[idxKey] = 0; } else { st[idxKey] = i; }
} else {
var len = section(key)._len;
st[idxKey] = (st[idxKey] + (m[2] === 'next' ? 1 : -1) + len) % len;
}
render();
return;
}
if (act === 'onTheme') { st.light = !st.light; applyTheme(); render(); }
if (act === 'onReload') { e.preventDefault(); window.location.reload(); }
});
document.addEventListener('submit', function (e) {
var f = e.target.closest('[data-act="onQuote"]');
if (!f) return;
e.preventDefault();
st.sent = true;
render();
});
function applyTheme() {
document.documentElement.setAttribute('data-theme', st.light ? 'light' : 'dark');
try { localStorage.setItem('armodilo-worship-theme', st.light ? 'light' : 'dark'); } catch (e) {}
}
function stackNavs() {
var header = document.querySelector('.worship-header');
var nav1 = document.querySelector('[data-index]');
var nav2 = document.querySelector('[data-index2]');
if (!header || !nav1) return;
var hH = Math.floor(header.getBoundingClientRect().height);
var n1H = Math.floor(nav1.getBoundingClientRect().height);
nav1.style.top = hH + 'px';
if (nav2) nav2.style.top = (hH + n1H - 1) + 'px';
var two = hH + n1H;
var root = document.documentElement;
root.style.setProperty('--scroll-pad-top', two + 'px');
root.style.setProperty('--scroll-pad', (two + (nav2 ? Math.floor(nav2.getBoundingClientRect().height) - 1 : 0)) + 'px');
var figTop = two + 24;
each('[data-chapter] figure', function (f) {
f.style.top = getComputedStyle(f).position === 'sticky' ? figTop + 'px' : '';
});
}
function paintNav() {
var nav = document.querySelector('[data-index]');
var nav2 = document.querySelector('[data-index2]');
var b1 = nav ? nav.getBoundingClientRect().bottom : 0;
var probe = b1 + (nav2 && nav2.getBoundingClientRect().top <= b1 + 1 ? nav2.getBoundingClientRect().height : 0) + 8;
var targets = [];
each('[data-chapter]', function (s) { targets.push({ attr: 'data-jump', id: s.getAttribute('data-chapter'), el: s }); });
each('[data-part2]', function (s) { targets.push({ attr: 'data-jump2', id: s.getAttribute('data-part2'), el: s }); });
var active = null;
for (var i = 0; i < targets.length; i++) {
if (targets[i].el.getBoundingClientRect().top <= probe) active = targets[i];
}
each('[data-jump],[data-jump2]', function (a) {
a.setAttribute('data-on', (!!active && a.getAttribute(active.attr) === active.id) ? '1' : '0');
});
}
function boot() {
try { st.light = localStorage.getItem('armodilo-worship-theme') === 'light'; } catch (e) {}
applyTheme();
render();
stackNavs();
paintNav();
var onScroll = function () {
cancelAnimationFrame(navRaf);
navRaf = requestAnimationFrame(paintNav);
};
window.addEventListener('scroll', onScroll, { passive: true });
document.addEventListener('visibilitychange', function () { if (!document.hidden) paintNav(); });
var onResize = function () { stackNavs(); paintNav(); };
window.addEventListener('resize', onResize);
window.addEventListener('load', onResize);
if (document.fonts && document.fonts.ready) document.fonts.ready.then(stackNavs);
setTimeout(onResize, 400);
if (window.ResizeObserver) {
var ro = new ResizeObserver(stackNavs);
['.worship-header', '[data-index]', '[data-index2]'].forEach(function (sel) {
var el = document.querySelector(sel);
if (el) ro.observe(el);
});
}
var queue = [];
Object.keys(DATA).forEach(function (k) {
DATA[k].models.forEach(function (m) { m.shots.forEach(function (s) { queue.push(s.src); }); });
});
var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 200); };
(function pump() {
queue.splice(0, 6).forEach(function (src) { var i = new Image(); i.decoding = 'sync'; i.src = src; });
if (queue.length) idle(pump);
})();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();